import React from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'

import 'filepond/dist/filepond.min.css'
import './styles/theme-overrides.css'

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import { registerPlugin } from 'react-filepond'
import AuthenticatedRoutes from './views/AuthenticatedRoutes'
import AuthPage from './views-2/pages/auth/AuthPage'
registerPlugin(FilePondPluginFileValidateType)

const App: React.FC = () => {
  // 828 const [client, setClient] = useState<ApolloClient<any> | null>(null)

  /* 828
  useEffect(() => {
    const init = async (): Promise<void> => {
      setClient(await BaseService.initProximaClient())
    }
    init().catch(console.error)
  }, [])

   */

  const theme = createTheme({
    typography: {
      fontFamily: ['Nunito'].join(',')
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Redirect exact from={'/'} to={'/app'} />
          <Route exact={false} path={'/auth'}>
            <AuthPage />
          </Route>
          <Route exact={false} path={'/'}>
            <AuthenticatedRoutes />
          </Route>
        </Switch>
      </Router>


    </ThemeProvider>
  )
}

export default App
